/**
 * API URLs for FlexFlow ERP
 *
 * All URLs are derived from the central config file.
 * To change app connection, edit: /src/config/app.config.js
 */

import config from "../config/app.config"

// ===========================================
// RE-EXPORT CONFIG VALUES
// ===========================================

export const API_URL = config.API_URL
export const APP_NAME = config.APP_NAME + "/"
export const APP_API_KEY = config.APP_API_KEY

// Base URL for FlexFlow app database
export const FLEXFLOW = config.APP_URL

// ===========================================
// AUTHENTICATION
// ===========================================

export const POST_LOGIN = API_URL + config.APP_NAME + "/user/session"

// ===========================================
// TASKS
// ===========================================

export const GET_TASKS = FLEXFLOW + "_table/tasks?filter=(status!=FINISHED)"
export const GET_ALL_TASKS = FLEXFLOW + "_table/tasks"
export const GET_TASKS_OF_ORDER = FLEXFLOW + "_table/tasks"
export const CREATE_TASK = FLEXFLOW + "_table/tasks"
export const GET_TYPES = FLEXFLOW + "_table/taskTypes"

// ===========================================
// CUSTOMERS
// ===========================================

export const GET_CUSTOMERS = FLEXFLOW + "_table/customers"
export const CREATE_CUSTOMER = FLEXFLOW + "_table/customers"

// ===========================================
// ORDERS
// ===========================================

export const GET_ORDERS = FLEXFLOW + "_table/custorders"
export const CREATE_ORDER = FLEXFLOW + "_table/custorders"

// ===========================================
// PRODUCTS
// ===========================================

export const GET_PRODUCTS = FLEXFLOW + "_table/products"
export const CREATE_PRODUCT = FLEXFLOW + "_table/products"

// ===========================================
// PROVIDERS
// ===========================================

export const GET_PROVIDERS = FLEXFLOW + "_table/providers"

// ===========================================
// INVOICES
// ===========================================

export const INVOICES = FLEXFLOW + "_table/invoices"

// ===========================================
// PAYMENTS
// ===========================================

export const PAYMENTS = FLEXFLOW + "_table/payments"

// ===========================================
// LOANS
// ===========================================

export const CREATE_LOAN = FLEXFLOW + "_table/stockloans"

// ===========================================
// SHIPPING
// ===========================================

export const SHIPPING = FLEXFLOW + "_table/shipments"
export const VEHICLES = FLEXFLOW + "_table/vehicles"

// ===========================================
// SALESPERSONS
// ===========================================

export const SALESPERSONS = FLEXFLOW + "_table/salespersons"

// ===========================================
// SETTINGS
// ===========================================

export const GET_BANKS = FLEXFLOW + "_table/banks"
export const GET_CODES = FLEXFLOW + "_table/managecodes"
export const COMPANY_DETAILS = FLEXFLOW + "_table/companydetails"

// ===========================================
// SYSTEM USER MANAGEMENT
// ===========================================

export const SYSTEM_USERS = API_URL + "system/user"
export const SYSTEM_ROLES = API_URL + "system/role"
export const SYSTEM_APPS = API_URL + "system/app"
export const DEFAULT_APP_ID = 6

// ===========================================
// INVOICE COMPANIES
// ===========================================

export const INVOICE_COMPANIES = FLEXFLOW + "invoice-companies"

// ===========================================
// VAT CATEGORIES
// ===========================================

export const VAT_CATEGORIES = FLEXFLOW + "vat-categories"

// ===========================================
// QUOTES (CPQ compositions)
// ===========================================

export const QUOTES = FLEXFLOW + "_table/quotes"

// ===========================================
// FINISH GROUPS & OPTIONS
// ===========================================

export const FINISH_GROUPS = FLEXFLOW + "_table/finish_groups"
export const FINISH_OPTIONS = FLEXFLOW + "_table/finish_options"

// ===========================================
// FILE STORAGE
// ===========================================

export const FILES_API = FLEXFLOW + "files"
